/* eslint-disable */
// AUTO-GENERATED - DO NOT EDIT
import { z, testRegex } from '@talbenmoshe/atlas-api/client';
export { toSnakeCase } from './caseTransform.js';
// ============ Component Validation Schemas ============
export const ServiceStatusResponseSchema = z.object({
    service: z.string(),
    databaseValue: z.string(),
}).loose();
export const SignedInAccountResponseSchema = z.object({
    accountId: z.string(),
    email: z.string(),
}).loose();
export const NotSignedInErrorSchema = z.object({
    reason: z.literal('not-signed-in'),
}).loose();
export const TripResponseSchema = z.object({
    id: z.uuid(),
    title: z.string(),
    version: z.number().int().min(1),
    createdAt: z.iso.datetime(),
}).loose();
export const TripListResponseSchema = z.object({
    trips: z.array(TripResponseSchema),
}).loose();
export const CreateTripBodySchema = z.object({
    title: z.string(),
}).loose();
export const InvalidTripTitleErrorSchema = z.object({
    reason: z.literal('invalid-title'),
}).loose();
// ============ Request Schemas ============
export const GetTripOsServerStatusRequestSchema = z.object({}).loose();
export const GetSignedInAccountRequestSchema = z.object({}).loose();
export const ListTripsRequestSchema = z.object({}).loose();
export const CreateTripRequestSchema = z.object({
    idempotencyKey: z.string().min(1).max(255),
    title: z.string(),
}).loose();
// ============ Response Schemas ============
export const ServiceStatusResponseResponseSchema = ServiceStatusResponseSchema;
export const SignedInAccountResponseResponseSchema = SignedInAccountResponseSchema;
export const TripListResponseResponseSchema = TripListResponseSchema;
export const TripResponseResponseSchema = TripResponseSchema;
// ============ Inferred Type Exports ============
// These types represent the transformed output (camelCase) from Zod schemas.
// Use these types for consumer-facing APIs instead of wire-format types.
//# sourceMappingURL=TripOsServerAPISchemas.js.map